import React from 'react';
import PropTypes from 'prop-types';
import { Tiles } from 'wsm-tiles';
import { usePaginationContext } from '../../contexts/PaginationContext';
import Pagination from '../pagination/Pagination';

const TilesSection = ({ tileData }) => {
	const { currentPage } = usePaginationContext();

	return (
		<>
			<div
				className="w-100 mx-auto p-0"
				style={{ maxWidth: '1200px' }}
				role="main"
				aria-label={`Location results, page ${currentPage || 1}`}
			>
				<Tiles
					type="location"
					data={tileData}
					layout="grid"
					className="justify-content-center"
				/>
			</div>

			<div
				className="w-100 py-4 d-flex justify-content-center align-items-center"
				role="navigation"
				aria-label="Pagination Navigation"
			>
				<Pagination />
			</div>
		</>
	);
};

TilesSection.propTypes = {
	tileData: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default TilesSection;
